import React from 'react';
import { Link } from 'react-router-dom';
import './PetList.css'
import { Button, Input, IconButton, TextField, Card, CardActions, Box } from '@mui/material/';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { CardActionArea } from '@mui/material';
import Grid from '@mui/material/Grid';
import DeleteIcon from '@mui/icons-material/Delete';
import Divider from '@mui/material/Divider';
import { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import { getDoc, addDoc, doc, updateDoc, deleteDoc, setDoc, collection, getDocs, query, where, onSnapshot } from "@firebase/firestore";
import {db, storage } from '../firebase-config';



function BrowseCardItem(props) {

  const [userAccountDetails, setUserAccountDetails] = useState({});
  const [isLoading, setIsLoading] = useState(true)

  const getShelterDetails = async () => {
    console.log(props.shelterID)
    const accountRef = doc(db, "accounts", props.shelterID)
    const testData = await getDoc(accountRef);
    setUserAccountDetails(testData.data())
    setIsLoading(false)  }
  
  useEffect(() => {
    getShelterDetails()
    console.log(userAccountDetails.type)
  }, [props]);


  if (!isLoading ) {
    return (
      <>
      <Box sx={{flexGrow: 1 }}>
          <Grid 
            container  
            
            justifyContent="center"
            alignItems="center">
            <Grid item xs={6} sx={{
            margin: "8px",  
            boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
            "&:hover": {
              boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
            }}}>
              <Card variant="outlined" sx={{ display: 'flex', background: "#fffaf0" }}>
                  <CardMedia
                    component="img"
                    image={props.src}
                    sx={{ width: 200 }}
                    alt=".\public\images\D5.jpg">
                  </CardMedia>
                  <Box sx={{ display: 'flex', flexDirection: 'column'}}>
                    <CardContent sx={{ flex: '1 0 auto' }}>
                    
                      <Typography gutterBottom variant="h4" component="div"> {props.name}</Typography>
                      <Divider/>
                        <Typography sx={{ fontSize: 18, marginTop: "4px"}} variant="body2" color="text.secondary"> Animal: {props.species} </Typography>
                        <Typography sx={{ fontSize: 18 }} variant="body2" color="text.secondary"> Age: {props.age} </Typography>
                        <Typography sx={{ fontSize: 18 }} variant="body2" color="text.secondary"> Species: {props.species} </Typography>
                        <Typography sx={{ fontSize: 18 }} variant="body2" color="text.secondary"> Breed: {props.breed} </Typography>
                        <Typography sx={{ fontSize: 18 }} variant="body2" color="text.secondary"> Disposition: {props.disposition} </Typography>
                        <Typography sx={{ fontSize: 18 }} variant="body2" color="text.secondary"> Description: {props.description} </Typography>
                        <Typography sx={{ fontSize: 18 }} variant="body2" color="text.secondary"> Availability: {props.availability} </Typography>
                      <CardActions>
                        <Button
                          variant="contained"
                          onClick={(e) => {props.handleAdoptClick(e, props.id)}} 
                          className='browse-form-input-btn form-input-btn'
                          disabled={props.availability !== 'available'}>
                          Adopt
                        </Button>
                      </CardActions>
                    </CardContent>
                  </Box>
                  {/* <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <CardContent sx={{ flex: '1 0 auto' }}>
                  <Typography gutterBottom variant="h4" component="div"> {props.shelterName}</Typography>
                      <Divider/>
                        <Typography sx={{ fontSize: 18, marginTop: "4px"}} variant="body2" color="text.secondary"> Animal: {props.species} </Typography>
                        <Typography sx={{ fontSize: 18 }} variant="body2" color="text.secondary"> Age: {props.age} </Typography>
                      </CardContent>
                  </Box> */}
                </Card>
              </Grid>
            
            
            <Grid item xs={4} sx={{
            margin: "8px",  
            boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
            "&:hover": {
              boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"}
            }}>
              <Box sx={{ display: 'flex', flexDirection: 'column'}}>
              <Card variant="outlined" sx={{ display: 'flex', background: "#fffaf0" }}>
              
                <CardContent sx={{ flex: '1 0 auto' }}>
                <Typography sx={{ fontSize: 20 }} component="div"> {userAccountDetails.shelter.name} </Typography>
                      <Divider/>
                    <Typography sx={{ fontSize: 18 }} variant="body2" color="text.secondary"> {userAccountDetails.contactInfo.street}, {userAccountDetails.contactInfo.city}, {userAccountDetails.contactInfo.state} </Typography>
                    <Typography sx={{ fontSize: 18 }} variant="body2" color="text.secondary"> {userAccountDetails.contactInfo.zipCode} </Typography>
                    <Divider/>
                    <Typography sx={{ fontSize: 18 }} variant="body2" color="text.secondary"> Phone: {userAccountDetails.contactInfo.phoneNumber} </Typography>
                    <Typography sx={{ fontSize: 18 }} variant="body2" color="text.secondary"> {userAccountDetails.shelter.website} </Typography>
                    <Typography sx={{ fontSize: 18 }} variant="body2" color="text.secondary"> {userAccountDetails.contactInfo.email} </Typography>

                </CardContent>
                </Card>
                
              </Box>
            
            </Grid>
            </Grid>
            </Box>
            
            {/* <figure className='browse-cards__item__pic-wrap'>
              <img
                className='browse-cards__item__img_small'
                alt='Profile Headshot'
                src={props.src}
              />
            </figure>
            <table className='browse-cards__item__text'>
              <tr>
                <th>Species: </th>
                <th>{props.species}</th>
              </tr>
              <tr>
                <th>Breed: </th>
                <th>{props.breed}</th>
              </tr>
              <tr>
                <th>Disposition: </th>
                <th>{props.disposition}</th>
              </tr>
              <tr>
                <th>Availability: </th>
                <th>{props.availability}</th>
              </tr>
              <tr>
                <th>Age: </th>
                <th>{props.age}</th>
              </tr>   */}
              {/* <h5>{props.text}</h5> */}
            {/* </table>
          </div>
          <button 
            onClick={(e) => {props.handleAdoptClick(e, props.id)}} 
            className='browse-form-input-btn form-input-btn'>
            Adopt
          </button> */}

      </>
    );
  }
}

export default BrowseCardItem;